import aboutCardIcon1 from "../../images/icon/aboutus_card_icon1.svg"
import aboutCardIcon2 from "../../images/icon/aboutus_card_icon2.svg"
import aboutCardIcon3 from "../../images/icon/aboutus_card_icon3.svg"

 const data = {
    aboutDescription1: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur cites of the word in classical literature.',
    aboutDescription2: 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original a latin professor at Hampden-Sydney',
    aboutInfo: [
        {
            icon: aboutCardIcon1,
            title: "Gamming NFTs",
            text: "Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure."
        },
        {
            icon: aboutCardIcon2,
            title: "Play to Earn",
            text: 'Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original.'
        },
        {
            icon: aboutCardIcon3,
            title: "Metaverse Ready",
            text: 'Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure.'
        }
    ]
}

export default data;